import ReadingPane from "../../Elements/ReadingPane/ReadingPane";
import Image from "../../Elements/Image/Image";

export default function Home() {
    return (
        <>
            <div className="split margin-bottom-2em">
                <Image alt="a leg picture" className="reading-image float-right" src="/assets/DISPLAY1.jpg"/>
                <span className="halfWidth">Onlylegs is a premium subscription service hosted and filled by and with myself</span>
            </div>
            <div className="split margin-bottom-2em">
                <span className="halfWidth">None of the pictures will be explicit but as leg pictures are, they will be questionable.</span>
                <Image alt="another leg picture" className="reading-image float-left" src="/assets/DISPLAY2.jpg"/>
            </div>
            <div className="split margin-bottom-2em">
                <Image alt="another leg picture" className="reading-image float-left" src="/assets/DISPLAY3.jpg"/>
                <span className="halfWidth">A few examples can be seen here.</span>
            </div>
        </>
    )
}

